// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"785514e4","407":"33944385","534":"8ccfe04a","538":"fb90c24b","759":"d23e3d26"}[chunkId] + ".chunk.js";
};